(ns practitest.frontend.components.column-picker
  (:require
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.grid.columns-settings :as oldsettings]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.dndkit :as dndkit]
    [practitest.frontend.components2.search-box :as search-box]
    [reagent.core :as reagent]))

(defn- chip-inner [{:keys [ref drag-listeners class transform transition label on-remove]}]
  [:div (merge drag-listeners
               {:ref ref
                :class class
                :style {:transition transition :transform transform}})
   [icons/svg-grip-vertical-reduced]
   [:span.column-chip-label label]
   ;; NOTE: not using buttons/icon-button here because we need to stop propagation
   ;;       otherwise clicking on it triggers drag
   [:button.column-chip-remove
    {:type "button"
     :on-pointer-down dom/stop-propagation
     :on-click on-remove}
    [icons/mux-x]]])

(defn- sortable-chip [{:keys [id label on-remove]}]
  (let [{:keys [setNodeRef listeners active transition transform]} (dndkit/use-sortable id {})]
    [:f> chip-inner
     {:ref setNodeRef
      :drag-listeners listeners
      :class (str "column-chip" (when (= (:id active) id) " is-dragging"))
      :transition transition
      :transform (dndkit/build-transform-string transform)
      :label label
      :on-remove on-remove}]))

(defn- chips-row [empty-hint selected label-by-id on-reorder on-remove]
  [dndkit/dnd-context
   {:on-drag-end (fn [e]
                   (let [active (some-> e .-active .-id)
                         over (some-> e .-over .-id)]
                     (when (and active over (not= active over))
                       (on-reorder
                         (oldsettings/vector-move (vec selected)
                                                  (.indexOf selected active)
                                                  (.indexOf selected over))))))}
   [dndkit/sortable-context
    {:items selected
     :strategy dndkit/horizontalListSortingStrategy}
    (into [:div.column-picker-chips {:data-empty-hint empty-hint}]
          (for [id selected]
            ^{:key id}
            [:f> sortable-chip
             {:id id
              :label (label-by-id id id)
              :on-remove #(on-remove id)}]))]])

(defn- field-row [{:keys [id label checked? on-toggle]}]
  [:label.column-picker-row
   [:input {:type "checkbox"
            :checked checked?
            :on-change #(on-toggle id (dom/event-value %))}]
   [:span.column-picker-row-label label]])

(defn column-picker
  "Props:
  - `:available-fields`: vec of {:id :label} - all selectable fields
  - `:selected`:         vec of ids in display order (subset of available)
  - `:empty-hint`:       optional hint to show when nothing is selected
  - `:on-change`:        `(fn [new-selected])` - called with new ordered vec"
  [{:keys [available-fields selected on-change empty-hint]
    :or {empty-hint (get-translation "column-picker.empty"
                                     "No columns selected")}}]
  (reagent/with-let [search (reagent/atom "")]
    (let [selected-set (set selected)
          label-by-id (into {} (map (juxt :id :label)) available-fields)
          q @search
          rows (cond->> available-fields
                 (seq q) (filter #(fu/substring-search? (:label %) q)))
          toggle (fn [id checked?]
                   (on-change
                     (if checked?
                       (conj (vec selected) id)
                       (vec (remove #(= % id) selected)))))]
      [:div.column-picker
       [chips-row empty-hint selected label-by-id on-change
        (fn [id]
          (on-change (vec (remove #{id} selected))))]
       [search-box/search-textbox
        {:placeholder (get-translation "column-picker.search" "Search fields")
         :value @search
         :on-change #(reset! search (dom/event-value %))
         :on-clear-click #(reset! search "")}]
       [:div.column-picker-available
        (for [{:keys [id label]} rows]
          ^{:key id}
          [field-row {:id id
                      :label label
                      :checked? (contains? selected-set id)
                      :on-toggle toggle}])]])))
